<template>
  <div v-if="workStore.isModalOpen" class="modal fade show d-block modal-select-firma-lucru" tabindex="-1"
    style="background: rgba(0, 0, 0, 0.6); z-index: 100000;" @click.self="closeModal">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content shadow-lg border-0">
        <!-- Header -->
        <div class="modal-header bg-light py-4 px-6 border-bottom">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-40px bg-light-primary text-primary me-3 d-flex align-items-center justify-content-center rounded-3">
              <i class="fa-solid fa-building fs-3"></i>
            </div>
            <div>
              <h5 class="modal-title fw-bold text-dark mb-0">Selectează Firma de Lucru</h5>
              <small class="text-muted" v-if="workStore.pendingTargetRoute">
                Alege firma pentru a accesa secțiunea dorită
              </small>
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-icon btn-light btn-active-light-primary" @click="closeModal">
            <i class="fa-solid fa-xmark fs-5"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body p-6">
          <!-- Căutare inteligentă -->
          <div class="position-relative mb-4">
            <i class="fa-solid fa-magnifying-glass position-absolute top-50 translate-middle-y ms-4 text-muted fs-5"></i>
            <input
              ref="searchInputRef"
              type="text"
              class="form-control form-control-solid ps-12 pe-10"
              placeholder="Caută după denumire, CUI, utilizator..."
              v-model.trim="searchTerm"
              @input="onSearchInput"
              @keydown.esc="closeModal"
            />
            <button
              v-if="searchTerm"
              type="button"
              class="btn btn-icon btn-sm btn-active-light-secondary position-absolute top-50 end-0 translate-middle-y me-2"
              @click="clearSearch"
            >
              <i class="fa-solid fa-xmark text-muted"></i>
            </button>
          </div>

          <!-- Loading state -->
          <div v-if="loading" class="text-center py-8">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 text-muted fs-7">Se încarcă lista firmelor...</p>
          </div>

          <!-- Empty results -->
          <div v-else-if="!filteredFirme.length" class="text-center py-8">
            <div class="symbol symbol-50px bg-light-warning text-warning mb-3 d-inline-flex align-items-center justify-content-center rounded-circle">
              <i class="fa-solid fa-building-circle-xmark fs-2"></i>
            </div>
            <h6 class="fw-bold text-gray-800">Nicio firmă găsită</h6>
            <p class="text-muted fs-7 mb-0">Încearcă o altă căutare după CUI sau denumire.</p>
          </div>

          <!-- List of firms -->
          <div v-else class="list-group list-group-flush gap-2 max-h-400px overflow-auto pe-1">
            <a
              v-for="f in filteredFirme"
              :key="f.id"
              href="#"
              class="list-group-item list-group-item-action p-3 rounded border d-flex align-items-center justify-content-between transition-all"
              :class="{
                'border-primary bg-light-primary': workStore.firmaId === f.id,
                'border-gray-200 hover-elevate-up': workStore.firmaId !== f.id
              }"
              @click.prevent="selectFirma(f)"
            >
              <div class="d-flex align-items-center overflow-hidden me-3">
                <div class="symbol symbol-45px symbol-circle overflow-hidden me-3 flex-shrink-0 border">
                  <img v-if="f.sigla" :src="`/api/fisiere/sigla-firma/${f.id}`" alt="Sigla" style="object-fit: cover; width:100%; height:100%;" />
                  <span v-else class="symbol-label fw-bold bg-light-primary text-primary fs-5">
                    {{ (f.denumire || '?').charAt(0) }}
                  </span>
                </div>
                <div class="d-flex flex-column min-w-0">
                  <span class="text-gray-900 fw-bold fs-6 text-truncate">
                    {{ f.denumire }}
                    <span class="text-muted fw-normal fs-7 ms-1">#{{ f.id }}</span>
                  </span>
                  <div class="d-flex align-items-center gap-2 flex-wrap text-muted fs-8">
                    <span v-if="f.cui" class="fw-semibold">CUI: {{ f.cui }}</span>
                    <span v-if="f.user_name" class="d-none d-sm-inline">· Utilizator: {{ f.user_name }}</span>
                    <span v-if="f.tip_entitate" class="badge badge-light fw-bold py-0 px-1">{{ f.tip_entitate }}</span>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <span v-if="workStore.firmaId === f.id" class="badge badge-primary fw-bold px-3 py-2">
                  <i class="fa-solid fa-check me-1"></i> Activă
                </span>
                <span v-else class="btn btn-sm btn-light-primary fw-bold px-3 py-1">
                  Selectează
                </span>
              </div>
            </a>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer bg-light py-3 px-6 border-top d-flex justify-content-between">
          <div class="text-muted fs-8">
            Total disponibile: <span class="fw-bold">{{ filteredFirme.length }}</span> firme
          </div>
          <button type="button" class="btn btn-sm btn-light" @click="closeModal">
            Închide
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useWorkFirmStore } from '../../../stores/workFirmStore';
import axios from 'axios';

export default {
  name: 'ModalSelecteazaFirmaLucru',
  setup() {
    const workStore = useWorkFirmStore();
    return { workStore };
  },
  data() {
    return {
      searchTerm: '',
      firmeList: [],
      loading: false,
      searchDebounce: null,
    };
  },
  computed: {
    filteredFirme() {
      return this.firmeList || [];
    }
  },
  watch: {
    'workStore.isModalOpen'(val) {
      if (val) {
        this.searchTerm = '';
        this.fetchFirme();
        this.$nextTick(() => {
          if (this.$refs.searchInputRef) {
            this.$refs.searchInputRef.focus();
          }
        });
      }
    }
  },
  methods: {
    async fetchFirme() {
      this.loading = true;
      try {
        const res = await axios.get('/api/administrare/work/firme-toate', { params: { page: 1, per_page: 50 } });
        const rows = res.data?.data || res.data?.firme || res.data || [];
        this.firmeList = Array.isArray(rows) ? rows : [];
      } catch (err) {
        console.error('Eroare la incarcarea firmelor in modal:', err);
      } finally {
        this.loading = false;
      }
    },
    onSearchInput() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      const term = (this.searchTerm || '').trim();
      if (term.length < 2) {
        if (term.length === 0) this.fetchFirme();
        return;
      }
      this.searchDebounce = setTimeout(async () => {
        this.loading = true;
        try {
          const res = await axios.put('/api/administrare/work/cautare', { q: term });
          const rows = res.data?.firme || res.data || [];
          this.firmeList = Array.isArray(rows) ? rows : [];
        } catch (err) {
          console.error('Eroare cautare modal firme:', err);
        } finally {
          this.loading = false;
        }
      }, 300);
    },
    clearSearch() {
      this.searchTerm = '';
      this.fetchFirme();
    },
    selectFirma(f) {
      this.workStore.setFirma(f);
      const target = this.workStore.pendingTargetRoute;
      this.workStore.closeSelectModal();

      if (target) {
        // Redirecționează către submodulul țintă
        let path = '';
        if (typeof target === 'string') {
          path = target.replace(':firmaId', f.id);
        } else if (target.module) {
          path = `/administrare/work/${f.id}/${target.module}${target.submodule ? '/' + target.submodule : ''}`;
        }
        if (path && this.$route?.path !== path) {
          this.$router.push(path).catch(() => {});
        }
      } else {
        // Navighează la pagina principală de lucru a firmei
        const path = `/administrare/work/${f.id}`;
        if (this.$route?.path !== path) {
          this.$router.push(path).catch(() => {});
        }
      }
    },
    closeModal() {
      this.workStore.closeSelectModal();
    }
  }
};
</script>

<style scoped>
.hover-elevate-up {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.hover-elevate-up:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.max-h-400px {
  max-height: 400px;
}
</style>
